/** App brand — single modern indigo */

export const BRAND_PRIMARY = '#1F7A4D';
export const BRAND_PRIMARY_DARK = '#4338CA';
export const BRAND_PRIMARY_LIGHT = '#6366F1';

export const BRAND_ACCENT = BRAND_PRIMARY;
export const BRAND_ACCENT_DARK = BRAND_PRIMARY_DARK;
export const BRAND_ACCENT_LIGHT = BRAND_PRIMARY_LIGHT;

export const BRAND_PRIMARY_RGB = '79, 70, 229';
export const BRAND_ACCENT_RGB = BRAND_PRIMARY_RGB;

export const brandPrimaryScale = {
  50: '#eef2ff',
  100: '#e0e7ff',
  200: '#c7d2fe',
  300: '#a5b4fc',
  400: '#818cf8',
  500: BRAND_PRIMARY_LIGHT,
  600: BRAND_PRIMARY,
  700: BRAND_PRIMARY_DARK,
  800: '#3730a3',
  900: '#312e81',
  950: '#1e1b4b',
};

export const brandAccentScale = brandPrimaryScale;

/** @deprecated Use BRAND_PRIMARY */
export const BRAND_RED = BRAND_PRIMARY;
export const BRAND_RED_DARK = BRAND_PRIMARY_DARK;
export const BRAND_RED_LIGHT = BRAND_PRIMARY_LIGHT;
export const BRAND_PURPLE = BRAND_PRIMARY;
export const BRAND_PURPLE_DEEP = BRAND_PRIMARY_DARK;
export const BRAND_RED_RGB = BRAND_PRIMARY_RGB;
export const brandRedScale = brandPrimaryScale;

/**
 * Org theme — SINGLE SOURCE OF TRUTH for fallback colors.
 * Keys are the CSS custom properties applied to :root by applyOrgTheme()
 * (see utils/orgTheme.js). To add a new themeable token, add it here.
 * Used when an organization hasn't set custom branding colors.
 */
export const DEFAULT_ORG_THEME = {
  '--org-primary': '#1F7A4D', // purple-600
  '--org-accent': '#F2C94C',  // pink-500
  '--org-chrome': '#12372A',
  '--org-support': '#8FA83A',
};

/**
 * Text colours shown in Branding until an organization chooses its own. They are
 * only what the pickers start from: an organization that hasn't chosen a colour
 * keeps the portals' normal text colours (see styles/brand-text.css).
 */
export const DEFAULT_DARK_TEXT_COLOR = '#111827';
export const DEFAULT_LIGHT_TEXT_COLOR = '#FFFFFF';

/** Raw hex access for JS consumers (charts, color pickers, canvas). */
export const DEFAULT_ORG_PRIMARY_COLOR = DEFAULT_ORG_THEME['--org-primary'];
export const DEFAULT_ORG_ACCENT_COLOR = DEFAULT_ORG_THEME['--org-accent'];

export const DEFAULT_ORG_COLORS = {
  primaryColor: DEFAULT_ORG_PRIMARY_COLOR,
  accentColor: DEFAULT_ORG_ACCENT_COLOR,
};